/**
 * internal dependencies
 */
import { awsApiInstance } from '../api/aws-api';
import { apiRetry } from '../api/api-helper';
import useAuth from '../hooks/auth-hooks';

import { IHeartbeatResponse } from '../models/heartbeat.interface';
import { handleRouteError } from './route-helpers/route-error';

/**
 * Function to get Terminal Heartbeat from api
 * 
 * @param {Date} start the start date
 * @param {Date} end the end date
 * @param {string} id the terminal id
 */
const GetHeartBeat = async ( start: Date, end: Date, id: string ): Promise<IHeartbeatResponse> => {
  try {
    apiRetry(awsApiInstance);

    const { userId } = useAuth()!;

    const theID = id === '' ? null : id;

    const { data } = await awsApiInstance.get(`/terminal/heartbeat`, {
      params: {
        wpID: userId,
        terminalId: theID,
        startDate: start,
        endDate: end
      }
    });

    return data;
  } catch ( error ) {
    handleRouteError(error, 'Error getting heart beat data');
    throw(error);
  }
}

export default GetHeartBeat;

//:${stageVariables.lambdaAlias}